import {
    EQP_ASSIGN_USER,
    EQP_ASSIGN_USER_SUCCESS,
    EQP_ASSIGN_USER_ERROR,
    EQP_ASSIGN_TECH_USER_LIST,
    EQP_ASSIGN_TECH_USER_LIST_SUCCESS,
    EQP_ASSIGN_TECH_USER_LIST_ERROR,
    EQP_ASSIGN_UNIT_HEALTH,
    EQP_ASSIGN_UNIT_HEALTH_SUCCESS,
    EQP_ASSIGN_UNIT_HEALTH_ERROR,
    EQP_ASSIGN_DELIVERY_ORDER,
    EQP_ASSIGN_DELIVERY_ORDER_SUCCESS,
    EQP_ASSIGN_DELIVERY_ORDER_ERROR,
    EQP_ASSIGN_EQUIPMENT,
    EQP_ASSIGN_EQUIPMENT_SUCCESS,
    EQP_ASSIGN_EQUIPMENT_ERROR,
    EQP_ASSIGN_DOCUMENT_TYPE,
    EQP_ASSIGN_DOCUMENT_TYPE_SUCCESS,
    EQP_ASSIGN_DOCUMENT_TYPE_ERROR,
    EQP_ASSIGN_USER_ASSIGN,
    EQP_ASSIGN_USER_ASSIGN_SUCCESS,
    EQP_ASSIGN_USER_ASSIGN_ERROR,
    EQP_ASSIGN_LIST,
    EQP_ASSIGN_LIST_SUCCESS,
    EQP_ASSIGN_LIST_ERROR,
    EQP_ASSIGN_LIST_SEARCH_CHANGE,
    EQP_ASSIGN_LIST_PAGE_SET,
    EQP_ASSIGN,
    EQP_ASSIGN_SUCCESS,
    EQP_ASSIGN_ERROR,
    EQP_ASSIGN_HISTORY,
    EQP_ASSIGN_HISTORY_SUCCESS,
    EQP_ASSIGN_HISTORY_ERROR
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    user: {
        loading: false,
        data: []
    },
    technic: {
        loading: false,
        data: []
    },
    unithealth: {
        loading: false,
        data: []
    },
    deliveryorder: {
        loading: false,
        data: []
    },
    documenttype: {
        loading: false,
        data: []
    },
    equipment: {
        loading: false,
        data: []
    },
    userassign: {
        loading: false,
        data: []
    },
    assignhistory: {
        loading: false,
        data: []
    },
    assign: {
        data: [],
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            unithealth:'',
            deliveryorder:'',
            serial:'',
            equipment: '',
            userassign: '',
            documenttype:''
        },
        value: {
            unithealth: '',
            deliveryorder: '',
            serial: '',
            equipment: '',
            userassign: '',
            documenttype: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EQP_ASSIGN_USER:
            return {
                ...state,
                loading: true,
                user: {
                    ...state.user
                }
            }
        case EQP_ASSIGN_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: {
                    ...state.user,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_TECH_USER_LIST:
            return {
                ...state,
                loading: true,
                technic: {
                    ...state.technic
                }
            }
        case EQP_ASSIGN_TECH_USER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                technic: {
                    ...state.technic,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_TECH_USER_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_UNIT_HEALTH:
            return {
                ...state,
                loading: true,
                unithealth: {
                    ...state.unithealth
                }
            }
        case EQP_ASSIGN_UNIT_HEALTH_SUCCESS:
            return {
                ...state,
                loading: false,
                unithealth: {
                    ...state.unithealth,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_UNIT_HEALTH_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_DELIVERY_ORDER:
            return {
                ...state,
                loading: true,
                deliveryorder: {
                    ...state.deliveryorder
                }
            }
        case EQP_ASSIGN_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryorder: {
                    ...state.deliveryorder,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_DELIVERY_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_EQUIPMENT:
            return {
                ...state,
                loading: true,
                equipment: {
                    ...state.equipment
                }
            }
        case EQP_ASSIGN_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipment: {
                    ...state.equipment,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_EQUIPMENT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_DOCUMENT_TYPE:
            return {
                ...state,
                loading: true,
                documenttype: {
                    ...state.documenttype
                }
            }
        case EQP_ASSIGN_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                documenttype: {
                    ...state.documenttype,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_DOCUMENT_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_USER_ASSIGN:
            return {
                ...state,
                loading: true,
                userassign: {
                    ...state.userassign
                }
            }
        case EQP_ASSIGN_USER_ASSIGN_SUCCESS:
            return {
                ...state,
                loading: false,
                userassign: {
                    ...state.userassign,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_USER_ASSIGN_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case EQP_ASSIGN_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case EQP_ASSIGN_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case EQP_ASSIGN_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case EQP_ASSIGN_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case EQP_ASSIGN:
            return {
                ...state,
                assign: {
                    ...state.edit,
                    loading: false
                }
            }
        case EQP_ASSIGN_SUCCESS:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_ERROR:
            return {
                ...state,
                assign: {
                    ...state.assign,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case EQP_ASSIGN_HISTORY:
            return {
                ...state,
                loading: true,
                assignhistory: {
                    ...state.assignhistory
                }
            }
        case EQP_ASSIGN_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                assignhistory: {
                    ...state.assignhistory,
                    ...action.payload
                }
            }
        case EQP_ASSIGN_HISTORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};

